import React, { useCallback } from 'react';
import { useState, useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import SubmittedTable from './SubmittedTable';
import CustomPaginationActionsTable from './AddConsumdraftTable';
import PreviewEdit from './PreviewEdit';
import ArrowLeftIcon from '@mui/icons-material/ArrowLeft';
import {
  HeadingWrap, Span, CommonButton, PreDataWrap, IntReqWrapper, RequestClosureWarapperAccepted,
  RequestClosureWarapperRejected, AddRemarkButton, BackButtonSpan, ReqWrapper, StoreNameCont, ExtReqWrapper, PopupButton
} from '../../../../Styles/CommonStyles';
import TextField from '@mui/material/TextField';
import { useGetStoreOfficesQuery } from '../../../../features/storeoffices/storeofficesApiSlice';
import useAuth from '../../../../features/hooks/useAuth';
import Autocomplete from '@mui/material/Autocomplete';
import { useGetconsummasterQuery } from '../../../../features/consummaster/consummasterApiSlice';
import { useGetconsumcatQuery } from '../../../../features/consumcat/consumcatApiSlice';
import { useGetbrandmasterQuery } from '../../../../features/brandmaster/brandmasterApiSlice';
import { useGetVendorMasterQuery } from '../../../../features/vendormaster/vendormasterApiSlice';
import dayjs from 'dayjs';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { useNavigate } from 'react-router-dom';
import { useUploadFileMutation } from '../../../../features/fileupload/fileuploadApiSlice';
import { useGetUsersQuery } from '../../../../features/users/usersApiSlice';
import {useGetconsumablesQuery} from '../../../../features/consumable/consumableApiSlice';
import fetchPDF from '../../../../data/fetchPDF';
import { useGetpartnumberQuery } from '../../../../features/partnumber/partnumberApiSlice';
import PdfModal from '../../../../data/pdfmodal';


const Container = styled.div`
  width: 100%;
`
const Wrapper = styled.div`
  padding: 5px;
  display: flex;
  flex-direction: column;
`
const AllWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  align-items: space-around;
  flex-grow: 1;
  row-gap: 50px;
`
const DraftTableWrap = styled.div`
`
const DraftTableCont = styled.div`
`


const OptionContainer = styled.div`
  width:350px;
  display: flex;
  height:150px;
  background-color:#fff;
  /* align-items: center;
  justify-content: center; */
  color: #58548E;
  font-family: "Roboto","Helvetica","Arial",sans-serif;
  font-size: 1.2857142857142856rem;
  line-height: 1.334;
  letter-spacing: 0em;
  margin-left: 24px;
  font-weight: 700;
  cursor: pointer;
  position: relative;
  transition: box-shadow 0.3s;
  &:hover{
      box-shadow: rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px;
  }
`
const StyledButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-family: "Roboto","Helvetica","Arial",sans-serif;
  font-weight: 600;
  font-size: 0.75rem;
  line-height: 1.75;
  letter-spacing: 0.02857em;
  text-transform: uppercase;
  min-width: 64px;
  height: 40px;
  padding: 6px 16px;
  border-radius: 4px;
  border-width: 0;
  background-color: #008080;
  box-shadow: 0px 3px 1px -2px rgba(0,0,0,0.2),0px 2px 2px 0px rgba(0,0,0,0.14),0px 1px 5px 0px rgba(0,0,0,0.12);
  margin: 8px;
`
const InnerContainer = styled.div`
    display:flex;
    border-left: 3px solid #955EFF;
    align-items: center;
    position: absolute;
    top: 20%;
    bottom: 20%;
    padding: 25px;
  `
  const FormTabCont = styled.div`
  `
  const FormCont = styled.div``
  const BackArrowContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin-right: 20px;
    cursor: pointer;
  `
  const SelectContainer = styled.div`
    margin: 15px;
    display: flex;
    align-items: center;
  `
  const AsetfmContainer = styled.div`
    width: 100%;
    height: 100%;
  `
  const AsetfmWrapper = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
  `
  const LeftAsetfmWrapper = styled.div`
    width:50%;
    height: 100%;
    flex: 1;
  `
  const RightAsetfmWrapper = styled.div`
    width:50%;
    height: 100%;
    flex: 1;
  `
  const InputAsetfmWrapper = styled.div`
    margin: 10px;
    /* display:flex; */
    /* flex-direction:column; */
  `
  const StyledForm = styled.form`
    display: flex;
    flex-direction: column;
    padding: 10px;
  `
  const UploadPdfWrapper = styled.div`
    display: flex;
    align-items:center;
    margin-top:40px;
    margin-left: 10px;
  `
  const InputFile = styled.input`
    width: 180px;
    display: none;
  `
  const CustomFileUploadButton = styled.label`
    /* Add your desired button styles */
    background-color: #4caf50; /* Green */
    color: white;
    padding: 10px 15px;
    border: none;
    border-radius: 5px;
    margin-right:5px;
    cursor: pointer;
  `
  const ButtonContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 10px;
  `
  const ConfirmButton = styled(CommonButton)`
  `
  const DraftSubButtonCon = styled.div`
    display: flex;
    /* flex-direction: column; */
    align-items: center;
    justify-content: right;
    margin-top: 10px;
  `
  const ViewButton = styled.button`
    background-color: #4caf50; /* Green */
    color: white;
    padding: 10px 15px;
    border: none;
    border-radius: 5px;
    margin-right:5px;
    margin-left: 5px;
    cursor: pointer;  
  `
  const SelectFileReset = styled.button`
    background-color: transparent;
    color: #999;
    border: none;
    font-size: 35px;
    cursor: pointer;
    padding: 0;
    margin-left:2px;
  `
  const FinalObjInitialVal = {
    orderno:"", category:"", consumable:"", order_quantity:"", pur_store:"", cur_store:"",
    unit_price:"", oem:"", partno:"", vendor:"", alloc_ofc:"", purchase_date:null, installation_date:null,
    warrantyexp_date:null, ledge_ref:"", bill_ref:"", remarks:""   
  }

const AddConsumables = () => {
  const [bclick, setBclick] = useState('');
  const [clicked, setClicked] = useState();
  const inputFile = useRef(null);
  const inputPdfFile = useRef(null);
  const [reqid, setreqId] = useState("");
  const [selectedfile, setSelectedFile] = useState(null);
  const [reselectedfile, setReselectedFile] = useState(null);
  const [finalobj, setFinalobj] = useState(FinalObjInitialVal);
  const [submittedEditClick, setSubmittedEditClick] = useState('');
  const [fileName, setFileName] = useState("");
  const [finalSubClicked, setFinalSubClicked] = useState(false);
  const [draftSaveclicked, setDraftSaveclicked] = useState(false);
  const [conclicked, setConclicked] = useState(false);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  
  const navigate = useNavigate();


  // logged in user info
  const { id, email, designation, designationSuffix, numSuffix, office, roles } = useAuth()
  let user_current_office = (useSelector((state) => state.office.off))
  
  // Get auth token for API requests
  const token = useSelector(state => state.auth.token);

  
  
  const {
    data: allstoreoffices
  } = useGetStoreOfficesQuery('allstorelists', {
    refetchOnFocus: true,
    refetchOnMountOrArgChange: true
  });
  let tempstoredata = allstoreoffices ? Object.values(allstoreoffices?.entities) : []
  let allstoresdata = tempstoredata
  let storesNameArray = allstoresdata.map(elm => elm.storeoffice);

  const {consummaster} = useGetconsummasterQuery("consummaster", {
    selectFromResult: ({data}) => ({
      consummaster: data?.entities
    }),
  })

  const {consumcat} = useGetconsumcatQuery("consumcat", {
    selectFromResult: ({data}) => ({
      consumcat: data?.entities
    }),
  });

  const {brandmaster} = useGetbrandmasterQuery("brandmaster", {
    selectFromResult: ({data}) => ({
      brandmaster: data?.entities
    }),
  })
  const {partnumber} = useGetpartnumberQuery("partnumber", {
    selectFromResult: ({data}) => ({
      partnumber: data?.entities
    }),
  });

  const {vendormaster} = useGetVendorMasterQuery("vendormasterList", {
    selectFromResult: ({ data }) => ({
      vendormaster: data?.entities
    }),
  });

  //usercall/single user call
  const { getSingleuser } = useGetUsersQuery('userslist', {
    selectFromResult: ({ data }) => ({
      getSingleuser: data?.entities
    }),
  });

  const { addconsumable, refetch, isFetching, error } = useGetconsumablesQuery('userslist', {
    selectFromResult: ({ data }) => ({
      addconsumable: data?.entities
    }),
  });

  const [uploadFile, {isLoading}] = useUploadFileMutation();


  // handle file upload
  const handlePdfFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      if (file.type === 'application/pdf') {
        if(!reqid.length){
          setSelectedFile(file);
        } else {
          if(!addconsumable[reqid]?.pdfPath?.length){
            setSelectedFile(file);
          }else{
            setReselectedFile(file)
          }
        }
      } else {
        alert('Please select only PDF file.');
        event.target.value = null;
      }
    }
  }

  const handlePdfUploadButtonClick = () => {
    inputPdfFile?.current?.click();
  };

  const handleNewclick = () => {
    setBclick('new');
    // setConclicked(false);
    if(inputPdfFile.current){
      inputPdfFile.current.value = null;
  
    } 
    if(inputFile.current){
      inputFile.current.value = null;
    }
    // setSelectedFile(null);
    // setReselectedFile(null);
    // setFile(null);
    // setreqId("");
    // setClicked(false);
  }
  const handleDraftclick = () => {
    setBclick('draft')
  }
  // const handleConclick = () => {
  //   if (Object.values(assetmasters?.entities)?.find(x => x.Category === finalobj?.category).Asset.find(y => y.Name === finalobj?.name)?.Specifications?.length === Object.values(finalobj?.specification)?.length) {
  //     setConclicked(true)
  //   }
  //   else {
  //     return alert('Please select all the specifications')
  //   }
  // }
  const handleSubmittedclick = () => {
    setBclick('submitted')
    // setConclicked(false);
    if(inputPdfFile.current){
      inputPdfFile.current.value = null;

    } 
    if(inputFile.current){
      inputFile.current.value = null;
    }
    // setSelectedFile(null);
    // setReselectedFile(null);
    // setFile(null);
    // setreqId("");
    // setClicked(false);
  }
  const deleteSelectFile = () => {
    if (inputPdfFile.current) {
      inputPdfFile.current.value = null;
      inputPdfFile.current.type = "text";
      inputPdfFile.current.type = "file";
      setSelectedFile(null);
      setReselectedFile(null)
    }
  }
  const handleformInput = (event, name, newValue) => {
    let tempFinalObj = {...finalobj};
    if (event?.target?.name) {
      
      tempFinalObj = { ...tempFinalObj, [event.target.name]: event.target.value }
      setFinalobj(tempFinalObj);
    }
    if(event?.$d) {
      tempFinalObj = { ...tempFinalObj, [name]: event?.$d.toISOString() }
      setFinalobj(tempFinalObj);
    }
    if(newValue){
      if(["category", "name"].includes(name)){
        const {category,pur_store,cur_store,orderno, ...others} = tempFinalObj
        tempFinalObj = {...FinalObjInitialVal,orderno,category, pur_store, cur_store}
        // Note: Order number will be generated by server when saving
      }
      tempFinalObj = { ...tempFinalObj, [name]: newValue }
      setFinalobj(tempFinalObj);
    }
  }
  const handleQuantity = (e) => {
    const value = e.target.value;
    
    // Allow empty string for clearing the field
    if (value === "") {
      let tempFinalObj = {...finalobj}
      tempFinalObj = {...tempFinalObj, [e.target.name]: ""}
      setFinalobj(tempFinalObj);
      return;
    }
    
    // Check if the value is a valid number
    const numValue = parseInt(value, 10);
    if (isNaN(numValue) || numValue < 1) {
      return alert("Please enter a valid positive number for Quantity.")
    }
    
    let tempFinalObj = {...finalobj}
    tempFinalObj = {...tempFinalObj, [e.target.name]: numValue}
    setFinalobj(tempFinalObj);
  }

  
  const handleSubmitEditclick = (e, clicked, reqid) => {
    setSubmittedEditClick(clicked)
    setBclick("var")
    setreqId(reqid)
  }
  
  const genBackHandler = () => {
    setBclick('');
    // setFinalobj(FinalObjInitialVal);
  }
  const handleviewFile = () =>{
    setModalIsOpen(true)
  }
  const closeModal = () =>{
    setModalIsOpen(false);
  }

  const handleEditclick = async (e, clicked, reqid) => {
    setBclick('edit')
    setreqId(reqid)
    setClicked(false);
    let tempfinalObj = {...finalobj}
    const addconsumobj = addconsumable[reqid]
    for(let key in tempfinalObj){
      if(addconsumobj[key] !== undefined && addconsumobj[key] !== null){
          if(key === "order_quantity"){
            // Handle quantity field specifically to avoid NaN
            const quantityValue = parseInt(addconsumobj[key], 10);
            tempfinalObj[key] = isNaN(quantityValue) ? "" : quantityValue;
          } else {
            tempfinalObj[key] = addconsumobj[key];
          }
      }
    }
    setFinalobj(tempfinalObj)
    const file = await fetchPDF(addconsumobj, token);
    setSelectedFile(file)
    setFileName(file?.name);
  }

  const handleRefetchConsumables = useCallback(() => {
    refetch(); // Manually re-fetches the data
  }, [refetch]);



  const folderName = "contractdoc"
  let jsonData = {collection:"addconsumable", data:{}, type:"", oldPath:""}; // Update JSON data with actual data.
  // draft save
  const saveDraftHandle = async (e) => {

    setFinalSubClicked(false)
    e.preventDefault()

    //first time draft clicked handler
    if (!reqid?.length) {
      setDraftSaveclicked(true)
      let finaldraftdata = {...finalobj, addstatus: 'draft', status:"" }
      //Add final Object to jsonData
      jsonData.data = finaldraftdata;
      jsonData.type = "addnew"
      //Create FormData which will include both pdf file and json data
      const formData = new FormData();
      if(selectedfile) formData.append('file', selectedfile);
      formData.append('jsonData', JSON.stringify(jsonData));
      try {
        const res = await uploadFile({ formData, folder: folderName }).unwrap();
        let docid = res.insertedId;
        setreqId(docid);
        // Update finalobj with server-generated order number
        if (res.orderno) {
          setFinalobj(prev => ({ ...prev, orderno: res.orderno }));
        }
        handleRefetchConsumables();
        return alert(`${res.message}${res.orderno ? ' - Order No: ' + res.orderno : ''}`)
      } catch (err) {
        console.log(err)
      }
    }

    //Second time and there after draftclicked handler
    if (reqid.length) {
      const oldPath = addconsumable[reqid]?.pdfPath? addconsumable[reqid]?.pdfPath:"" ;
      let addstatus = { addstatus: 'draft' };
      let updatedbody = {...finalobj, ...addstatus, id: reqid }
      //Add final Object to jsonData
      jsonData.data = updatedbody;
      jsonData.type = "update";
      jsonData.oldPath = ((oldPath?.length && !selectedfile && !reselectedfile) || (oldPath?.length && reselectedfile))? oldPath:"";
      //Create FormData which will include both pdf file and json data
      const formData = new FormData();
      if(selectedfile && !oldPath?.length) formData.append('file', selectedfile);
      if(reselectedfile) formData.append('file', reselectedfile);
      formData.append('jsonData', JSON.stringify(jsonData));
      try {
        const res = await uploadFile({ formData, folder: folderName }).unwrap();
        handleRefetchConsumables();
        return alert(`${res?.message}`)
      } catch (err) {
        console.log(err)
      }
    } 
  }
  //******************************final submit***********************************************/
  const finalSubmitHandle = async () => {

    setFinalSubClicked(true)

    //if submit button clicked without saving draft button clicked any time
    let finalsubmitdata = { ...finalobj }
    if(!(finalsubmitdata?.order_quantity && !isNaN(parseInt(finalsubmitdata.order_quantity, 10)) && finalsubmitdata?.unit_price?.length && finalsubmitdata?.oem?.length && finalsubmitdata?.vendor?.length && finalsubmitdata?.purchase_date && finalsubmitdata?.installation_date && finalsubmitdata?.warrantyexp_date && finalsubmitdata?.pur_store?.length )){
        return alert("Please provide details in all Fields")
      }
    if (!reqid.length) {
      console.log("Entered no reqid length")
      try {
        let status = { status: 'draft' }
        let addstatus = { addstatus: 'submitted' }
        let curr_editstatus = { curr_editstatus: false }

        // add flow details
        let flow_details = {
          flow_data: [{
            person_details: { role: 'adder', id: id, name: getSingleuser && getSingleuser[id]?.name, office: user_current_office, designation: designation[user_current_office], designationSuffix: designationSuffix[user_current_office], numSuffix: numSuffix[user_current_office] },
            editstatus: false,
            status: 'draft',
            remarks: '',
            time_stamp: new Date()
          }]
        }
        let body = { ...finalobj, ...addstatus, ...flow_details, ...status, ...curr_editstatus }
        //Add final Object to jsonData
        jsonData.data = body;
        jsonData.type = "addnew";
        //Create FormData which will include both pdf file and json data
        const formData = new FormData();
        if(selectedfile) formData.append('file', selectedfile);
        formData.append('jsonData', JSON.stringify(jsonData));
        const res = await uploadFile({ formData, folder: folderName }).unwrap();
        handleRefetchConsumables();
        // await addNewAsset(body)
        // await addNewaddassetDoc(addassetDocbody)
        navigate('/management/consumables/consumman')
        return alert(`Submitted successfully${res.orderno ? ' - Order No: ' + res.orderno : ''}`)
      } catch (err) {
        return alert(`Error:${err}`)
      }
    }

    // if submit button clicked after saving draft button clicked
    if (reqid?.length) {
      console.log("Entered reqid length")
      try {
        let status = { status: 'draft' }
        let addstatus = { addstatus: 'submitted' }
        let curr_editstatus = { curr_editstatus: false }

        // add flow details
        console.log(addconsumable);
        console.log(reqid);
        let oldflow_data = addconsumable[reqid]?.flow_data? addconsumable[reqid]?.flow_data:[];
        console.log(oldflow_data);
        let flow_details = {
          flow_data: [...oldflow_data, {
            person_details: { role: 'adder', id: id, name: getSingleuser && getSingleuser[id]?.name, office: user_current_office, designation: designation[user_current_office], designationSuffix: designationSuffix[user_current_office], numSuffix: numSuffix[user_current_office] },
            editstatus: false,
            status: 'draft',
            remarks: '',
            time_stamp: new Date()
          }]
        }
        const oldPath = addconsumable[reqid]?.pdfPath? addconsumable[reqid]?.pdfPath:"" ;
        let body = { ...finalobj, ...addstatus, ...flow_details, ...status, ...curr_editstatus, id: reqid }
        //Add final Object to jsonData
        jsonData.data = body;
        jsonData.type = "update";
        jsonData.oldPath = ((oldPath?.length && !selectedfile && !reselectedfile) || (oldPath?.length && reselectedfile))? oldPath:"";

        //Create FormData which will include both pdf file and json data
        const formData = new FormData();
        if(selectedfile && !oldPath?.length) formData.append('file', selectedfile);
        if(reselectedfile) formData.append('file', reselectedfile);
        formData.append('jsonData', JSON.stringify(jsonData));
        const res = await uploadFile({ formData, folder: folderName }).unwrap();
        handleRefetchConsumables();
        navigate('/management/consumables/consumman')
        return alert('Submitted')
      } catch (err) {
        return alert(`Error:${err}`)
      }
    } 
  }

  //Using useeffect to set purchase store office.
  useEffect(() =>{
    if(user_current_office && allstoreoffices){
      let tempFinalobj = {...finalobj}
      if(Object.values(allstoreoffices?.entities)?.map(x => x.storeoffice).includes(user_current_office)){
        tempFinalobj.pur_store = user_current_office;
        tempFinalobj.cur_store = user_current_office;
      } else {
        tempFinalobj.pur_store = "";
        tempFinalobj.cur_store = "";
      }
      setFinalobj(tempFinalobj);
    }
  },[allstoreoffices, user_current_office, bclick ]);


  // .filter( elm => elm.consumcategory === finalobj.category))
  // .filter(elm => (elm.consumcategory === finalobj.category && elm.consumable === finalobj.consumable && elm.brand === finalobj.oem)).map( x => x.partno ))

  return (
    <Container>
      <Wrapper>
        <AllWrapper>
          {!['draft', 'new', 'submitted', 'var', 'edit'].includes(bclick) && <OptionContainer onClick={handleNewclick}><InnerContainer >Add New Consumables </InnerContainer></OptionContainer>}
          {!['draft', 'new', 'submitted', 'var', 'edit'].includes(bclick) && <OptionContainer onClick={handleDraftclick}><InnerContainer >Draft Add Consumables </InnerContainer></OptionContainer>}
          {!['draft', 'new', 'submitted', 'var', 'edit'].includes(bclick) && <OptionContainer onClick={handleSubmittedclick}><InnerContainer >Submitted Consumables </InnerContainer></OptionContainer>}
        </AllWrapper>
      </Wrapper>
      <FormTabCont>
      {
        (bclick === 'draft') && <DraftTableCont>
          <DraftTableWrap>
            <BackArrowContainer onClick={genBackHandler}><ArrowLeftIcon /><BackButtonSpan >Back</BackButtonSpan></BackArrowContainer>
            <CustomPaginationActionsTable handleEditclick={handleEditclick} />
          </DraftTableWrap>
        </DraftTableCont>}
        {submittedEditClick === 'clicked' ? <PreviewEdit setFinalobj = {setFinalobj} fetchPDF={fetchPDF} reqid={reqid} setreqId={setreqId} setBclick={setBclick} setSubmittedEditClick={setSubmittedEditClick} setSelectedFile={setSelectedFile} setClicked={setClicked} /> :
      (bclick === 'submitted') && <DraftTableCont>
        <DraftTableWrap>
          <BackArrowContainer onClick={genBackHandler}><ArrowLeftIcon /><BackButtonSpan >Back</BackButtonSpan></BackArrowContainer>
          <SubmittedTable handleSubmitEditclick={handleSubmitEditclick} />
        </DraftTableWrap>
      </DraftTableCont>}
      {(['new', 'edit'].includes(bclick)) && <FormCont>
            <BackArrowContainer onClick={genBackHandler}><ArrowLeftIcon /><BackButtonSpan >Back</BackButtonSpan></BackArrowContainer>
            {Object.values(allstoreoffices?.entities)?.map(x => x.storeoffice).includes(user_current_office) && <SelectContainer>
              <Autocomplete
                disabled={true}
                id="combo-box-demo"
                name="pur_store"
                options={storesNameArray?.map(elm => elm) || []}
                sx={{ width: 600 }}
                value={finalobj?.pur_store}       
                renderInput={(params) => <TextField {...params} label="Selected Store" />}
              />
            </SelectContainer>}
            <SelectContainer>
              <Autocomplete
                disabled={clicked}
                id="combo-box-demo"
                options={allstoresdata?.find( x => x.storeoffice === finalobj?.pur_store)?.ApplConsumCateg || []}
                sx={{ width: 600 }}
                value={finalobj?.category}
                onChange={(event, newValue) => handleformInput(event, "category", newValue)    
                }
                renderInput={(params) => <TextField {...params} label="Select Category" />}
              />
            </SelectContainer>
            {finalobj?.category?.length ? <SelectContainer>
              <Autocomplete
                disabled={clicked}
                id="combo-box-demo"
                options={Object.values(consummaster).filter( x => x.consumcategory === finalobj?.category ).map(elm => elm.consumable)}
                sx={{ width: 600 }}
                value={finalobj?.consumable}
                onChange={(event, newValue) => handleformInput(event, "consumable", newValue)    
              }
                renderInput={(params) => <TextField {...params} label="Select Consumable Name" />}
              />
            </SelectContainer>:null}
            {finalobj?.consumable?.length ? <><HeadingWrap><Span>Provide following details of Consumable</Span></HeadingWrap>
              {
              // clicked ?
                <AsetfmContainer>
                  <StyledForm>
                    <AsetfmWrapper>
                      <LeftAsetfmWrapper>                       
                        <InputAsetfmWrapper>
                          <Autocomplete
                            id="combo-box-demo"
                            options={brandmaster? Object.values(brandmaster).map(x => x.name):[]}
                            sx={{ width: 400 }}
                            value={finalobj?.oem}
                            onChange={(event, newValue) => handleformInput(event, "oem", newValue)
                            //   (event, newValue) => {
                            //   setBrand(newValue);
                            // }
                          }
                            renderInput={(params) => <TextField {...params} label="Select Brand/OEM Name:" />}
                          />
                        </InputAsetfmWrapper>
                        <InputAsetfmWrapper>
                          <Autocomplete
                            id="combo-box-demo"
                            options={partnumber? Object.values(partnumber).filter(elm => (elm.consumcategory === finalobj.category && elm.consumable === finalobj.consumable && elm.brand === finalobj.oem)).map( x => x.partno ):[]}
                            sx={{ width: 400 }}
                            value={finalobj?.partno}
                            onChange={(event, newValue) => handleformInput(event, "partno", newValue)     
                          }
                            renderInput={(params) => <TextField {...params} label="Enter Part No./Details:" />}
                          />
                        </InputAsetfmWrapper>
                        <InputAsetfmWrapper>
                          <Autocomplete
                            id="combo-box-demo"
                            options={vendormaster? Object.values(vendormaster)?.map(x => x.vendorname):[]}
                            sx={{ width: 400 }}
                            value={finalobj?.vendor}
                            onChange={(event, newValue) => handleformInput(event, "vendor", newValue)
                          }
                            renderInput={(params) => <TextField {...params} label="Enter Vendor Name" />}
                          />
                        </InputAsetfmWrapper>                        
                        <InputAsetfmWrapper>
                          <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DemoContainer components={['DatePicker', 'DatePicker']}>
                              <DateTimePicker
                                label="Purchase date"
                                value={dayjs(finalobj?.purchase_date)}
                                format="DD/MM/YYYY hh:mm a"
                                // required={finalSubClicked}
                                onChange={(event) => handleformInput(event, 'purchase_date')}
                              />
                            </DemoContainer>
                          </LocalizationProvider>
                        </InputAsetfmWrapper>
                        <InputAsetfmWrapper>
                          <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DemoContainer components={['DatePicker', 'DatePicker']}>
                              <DateTimePicker
                                label="Installation date"
                                value={dayjs(finalobj?.installation_date)}
                                format="DD/MM/YYYY hh:mm a"
                                onChange={(event) => handleformInput(event, 'installation_date')}
                              />
                            </DemoContainer>
                          </LocalizationProvider>
                        </InputAsetfmWrapper>
                        <InputAsetfmWrapper>
                          <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DemoContainer components={['DatePicker', 'DatePicker']}>
                              <DateTimePicker
                                label="warranty validity date"
                                value={dayjs(finalobj?.warrantyexp_date)}
                                format="DD/MM/YYYY hh:mm a"
                                // required={finalSubClicked}
                                onChange={(event) => handleformInput(event, 'warrantyexp_date')}
                              />
                            </DemoContainer>
                          </LocalizationProvider>
                        </InputAsetfmWrapper>           

                      </LeftAsetfmWrapper>
                      <RightAsetfmWrapper>
                        <InputAsetfmWrapper>
                          <TextField
                            style={{ width: '400px' }}
                            inputProps={{ style: { height: '38px' } }}
                            // required={finalSubClicked}
                            value={finalobj?.unit_price} name='unit_price' onChange={handleformInput} label="Unit Cost" size="small" variant="outlined" />
                        </InputAsetfmWrapper>
                        <InputAsetfmWrapper>
                          <TextField
                            style={{ width: '400px' }}
                            inputProps={{ style: { height: '38px' }, min: 1 }}
                            required={true}
                            type="number"
                            value={finalobj?.order_quantity || ""} 
                            name='order_quantity' 
                            onChange={handleQuantity} 
                            label="Enter the Quantity" 
                            size="small" 
                            variant="outlined" 
                          />
                        </InputAsetfmWrapper>
                        <InputAsetfmWrapper>
                          <TextField
                            style={{ width: '400px' }}
                            inputProps={{ style: { height: '38px' } }}
                            value={finalobj?.ledge_ref} name='ledge_ref' onChange={handleformInput} label="Any ledger Ref. No." size="small" variant="outlined" />
                        </InputAsetfmWrapper>
                        <InputAsetfmWrapper>
                          <TextField
                            style={{ width: '400px' }}
                            inputProps={{ style: { height: '38px' } }}
                            value={finalobj?.bill_ref} name='bill_ref' onChange={handleformInput} label="Billing Ref. No." size="small" variant="outlined" />
                        </InputAsetfmWrapper>
                        <InputAsetfmWrapper>
                          <TextField
                            style={{ width: '400px' }}
                            inputProps={{ style: { height: '38px' } }}
                            value={finalobj?.remarks} name='remarks' onChange={handleformInput} label="Remarks" size="small" variant="outlined" />
                        </InputAsetfmWrapper> 
                        <UploadPdfWrapper>
                          <InputFile type="file" onChange={handlePdfFileChange} ref={inputPdfFile}/>
                          <CustomFileUploadButton htmlFor="file-upload" onClick={handlePdfUploadButtonClick}>
                          Upload Related Contract Document
                          </CustomFileUploadButton>
                          {(selectedfile || reselectedfile) && <><span>{selectedfile? selectedfile.name: reselectedfile.name}</span><SelectFileReset type='button' onClick={() => deleteSelectFile()} >&times;</SelectFileReset><ViewButton type='button' onClick={handleviewFile}>View File</ViewButton></>}
                        </UploadPdfWrapper>                      
                      </RightAsetfmWrapper>
                    </AsetfmWrapper>
                  </StyledForm>
                  {/* <StyledButton onClick={backhandleClick}>Back</StyledButton> */}
                </AsetfmContainer>}
           </>:null}
            {<DraftSubButtonCon><StyledButton onClick={saveDraftHandle}>Save Draft</StyledButton>
              <StyledButton type='submit' onClick={finalSubmitHandle} disabled={isLoading}>{isLoading? "Loading...":"Submit"}</StyledButton></DraftSubButtonCon>}
          </FormCont>}

      </FormTabCont>
      <PdfModal
      show = {modalIsOpen}
      onClose = {closeModal}
      pdfUrl = {selectedfile? URL.createObjectURL(selectedfile) : reselectedfile? URL.createObjectURL(reselectedfile):null}
      />
    </Container>
  )
}

export default AddConsumables